import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICard } from '../../interfaces/card.interfaces';
import { Router } from '@angular/router';

@Component({
  selector: 'root-nav-card',
  templateUrl: './nav-card.component.html',
  styleUrls: ['./nav-card.component.scss'],
})
export class NavCardComponent {
  @Input() card: ICard;
  @Output() cardClick: EventEmitter<ICard> = new EventEmitter<ICard>();

  constructor(private router: Router) {}

  public get isSvgIcon(): boolean {
    return this.card.iconIsSvg === true;
  }

  public get isMatIcon(): boolean {
    return this.card.iconIsSvg === false;
  }

  public navigate() {
    if (this.card.route && this.card.route.length > 0) {
      if (this.card.route.startsWith('http')) {
        window.open(this.card.route, '_blank');
      } else {
        this.router.navigateByUrl(this.card.route);
      }
    } else {
      this.cardClick.emit(this.card);
    }
  }
}
